import { useTranslation } from 'react-i18next';

import { PageWithTable } from '../../ui/pageWithTable/PageWithTable';
import { BillsKeys } from './helper';
import { useBillsActions } from './useBillsActions';
import { BillPathsEnum } from '../routes';
import { TableWithSearch } from '../../ui/pageWithTable';

export const BillsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageWithTable
      title={t('billsPage.bills')}
      disclaimer={t('billsPage.infoMessage')}
      activeTab={BillsKeys.Bills}
      tabs={[
        {
          label: t('billsPage.bills'),
          url: BillPathsEnum.bills,
          key: BillsKeys.Bills,
          component: (
            <TableWithSearch
              showPaginationHelp
              showSearch
              useFormActions={useBillsActions}
            />
          ),
        },
      ]}
    />
  );
};
